export default {"src":"/_next/static/media/shield.673813f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};